import { useCreate } from '../../../../../../../api/react-query';

export function useEmpPortalMenuConfigCreate({ params }) {
  const {
    mutateAsync: createConfig,
    isLoading: isCreating,
    error,
  } = useCreate({
    url: 'config/empportalMenu/config',
    params,
  });

  return {
    createConfig,
    isCreating,
    error,
  };
}
